<template>
    <div class="el-package-group-wrapper">
        <div class="el-row">
            <div class="el-table-info">
                <div class="el-table-info__panel">
                    <ul class="mt-0">
                        <li>
                            {{ $t('table.data.label.ref')
                            }}<input
                                class="el-table-info__input el-table-info__input--sm"
                                :readonly="readonly"
                                v-model="blcPackage.Reference"
                            />
                        </li>
                        <li>
                            {{ $t('table.data.label.ord')
                            }}<input
                                class="el-table-info__input el-table-info__input--sm"
                                :readonly="readonly"
                                v-model="blcPackage.OrderNo"
                            />
                        </li>
                        <li>
                            <div
                                class="input-group-inline"
                                :class="{ readonly: readonly }"
                            >
                                <label class="form-label-inline">{{
                                    $t('table.data.label.supplier')
                                }}</label>
                                <v-select
                                    :items="suppliers"
                                    :readonly="readonly"
                                    item-text="SupplierName"
                                    combobox
                                    return-object
                                    v-model="supplier"
                                    required
                                >
                                </v-select>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="el-table-info__actions" v-if="!readonly">
                    <v-btn
                        class="el-table-info__btn el-table-info__btn--lg el-table-info__btn--primary btn btn--flat"
                        flat
                        @click="addItem"
                    >
                        {{ $t('button.text.addPackageItem') }}
                    </v-btn>
                    <v-btn
                        class="el-table-info__btn el-table-info__btn--sm el-table-info__btn--warning btn btn--flat"
                        flat
                        @click="$emit('delete-blc-package', blcPackage)"
                    >
                        {{ $t('button.text.delete') }}
                    </v-btn>
                </div>
            </div>
            <el-table
                :data="packageItems"
                class="el-table__inner-editable el-table__inner-editable--no-top-margin"
                :class="{ readonly: readonly }"
                style="width: 100%"
                border
            >
                <el-table-column :label="$t('table.column.description')">
                    <template slot-scope="{ row }">
                        <v-select
                            :items="descriptions"
                            :readonly="readonly"
                            combobox
                            v-model="row.Description"
                            required
                        >
                        </v-select>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('table.column.packageType')">
                    <template slot-scope="{ row }">
                        <v-select
                            :items="packageTypes"
                            :readonly="readonly"
                            combobox
                            v-model="row.PackageType"
                            required
                        >
                        </v-select>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('table.column.trackingReference')">
                    <template slot-scope="{ row }">
                        <input
                            class="el-table-input-text"
                            :readonly="readonly"
                            v-model="row.TrackingReference"
                        />
                    </template>
                </el-table-column>
                <el-table-column :label="$t('table.column.customerReference')">
                    <template slot-scope="{ row }">
                        <input
                            class="el-table-input-text"
                            :readonly="readonly"
                            v-model="row.CustomReference"
                        />
                    </template>
                </el-table-column>
                <el-table-column :label="$t('table.column.height')" width="100">
                    <template slot-scope="{ row }">
                        <input
                            class="el-table-input-text"
                            :readonly="readonly"
                            v-model="row.Height"
                        />
                    </template>
                </el-table-column>
                <el-table-column :label="$t('table.column.width')" width="100">
                    <template slot-scope="{ row }">
                        <input
                            class="el-table-input-text"
                            :readonly="readonly"
                            v-model="row.Width"
                        />
                    </template>
                </el-table-column>
                <el-table-column :label="$t('table.column.length')" width="100">
                    <template slot-scope="{ row }">
                        <input
                            class="el-table-input-text"
                            :readonly="readonly"
                            v-model="row.Length"
                        />
                    </template>
                </el-table-column>
                <el-table-column :label="$t('table.column.weight')" width="100">
                    <template slot-scope="{ row }">
                        <input
                            class="el-table-input-text"
                            :readonly="readonly"
                            v-model="row.Weight"
                        />
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="!readonly"
                    class-name="el-col__action--green"
                    width="30"
                    align="center"
                    :resizable="false"
                >
                    <template slot-scope="{ row }">
                        <i
                            class="material-icons"
                            @click="addDuplicateItem(row, blcPackage)"
                            >content_copy</i
                        >
                    </template>
                </el-table-column>
                <el-table-column
                    v-if="!readonly"
                    class-name="el-col__action--red"
                    width="30"
                    align="center"
                    :resizable="false"
                >
                    <template slot-scope="{ row }">
                        <i class="material-icons" @click="deleteItem(row)"
                            >delete</i
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'booking-blc-package',

    props: ['dataBlcPackage', 'actor', 'readonly', 'suppliers'],

    data() {
        return {
            blcPackage: this.dataBlcPackage,
            blcPackageId: this.dataBlcPackage.PackageGroupID || '',
            packageItems: this.dataBlcPackage.PackageItems,
            prevWatches: [],
            descriptions: [
                'Badrum',
                'Gips',
                'Isolering',
                'Kartonger',
                'Kolli över 1,1 ton',
                'Kök',
                'Övrigt',
                'Plyfa',
                'Rör',
                'Virke',
            ],
            packageTypes: [],
            supplier: {
                SupplierID: this.dataBlcPackage.SupplierID,
                SupplierName: this.dataBlcPackage.SupplierName,
            },
        }
    },
    watch: {
        blcPackage: {
            handler: _.debounce(function (newVal) {
                this.updateOrCreatePackage(newVal)
            }, 300),
            deep: true,
        },

        supplier(val) {
            if (_.isObject(val)) {
                this.blcPackage.SupplierID = val.SupplierID
                this.blcPackage.SupplierName = val.SupplierName
            } else {
                this.blcPackage.SupplierName = val
            }
        },
    },

    beforeDestroy() {
        this.unwatchItems()
    },

    created() {
        this.watchItems()
        this.populatePackageItems()
    },

    mounted() {
        Events.$on('set-supplier', (supplier) => {
            this.supplier = supplier
        })
    },

    methods: {
        unwatchItems() {
            this.prevWatches.map((unwatch) => unwatch())
        },
        populatePackageItems() {
            this.packageTypes = this.$t('packageTypes').split(',')
        },
        watchItems() {
            if (this.readonly) return

            this.unwatchItems()

            this.prevWatches = this.packageItems.map((item) => {
                return this.$watch(
                    () => {
                        return item
                    },
                    _.debounce((newVal) => {
                        this.updateOrCreatePackageItem(newVal)
                    }, 300),
                    {
                        deep: true,
                    }
                )
            })
        },

        async updateOrCreatePackage(blcPackage) {
            if (!this.actor) return

            if (this.blcPackageId) {
                this.updatePackage(blcPackage)
            } else {
                this.createPackage(blcPackage)
            }
        },

        async updateOrCreatePackageItem(item) {
            if (!this.actor) return

            if (!this.blcPackageId) {
                await this.createPackage(this.blcPackage)
            }
            if (item.PackageItemID) {
                this.updateItem(item)
            } else {
                this.createItem(item)
            }
        },

        async updatePackage(blcPackage) {
            return this.$http.put(
                `/Actor/${this.actor.ActorID}/PackageGroup/${this.blcPackageId}`,
                blcPackage
            )
        },

        async createPackage(blcPackage) {
            // Handle redundant empty row scenario
            // if (
            //     blcPackage &&
            //     blcPackage.PackageItems &&
            //     blcPackage.PackageItems.length === 1 &&
            //     blcPackage.PackageItems[0].PackageType === '' &&
            //     blcPackage.PackageItems[0].TrackingReference === '' &&
            //     blcPackage.PackageItems[0].Description === '' &&
            //     blcPackage.PackageItems[0].CustomReference === ''
            // ) {
            //     blcPackage.PackageItems = []
            // }

            let { data } = await this.$http.post(
                `/Actor/${this.actor.ActorID}/PackageGroup`,
                blcPackage
            )

            this.blcPackageId = data
        },

        async updateItem(item) {
            return this.$http.put(
                `/Actor/${this.actor.ActorID}/PackageGroup/${this.blcPackageId}/PackageItem/${item.PackageItemID}`,
                item
            )
        },

        async createItem(item) {
            let { data } = await this.$http.post(
                `/Actor/${this.actor.ActorID}/PackageGroup/${this.blcPackageId}/PackageItem`,
                item
            )

            item.PackageItemID = data
            return item.PackageItemID
        },

        addItem() {
            this.blcPackage.PackageItems.push({
                Height: 0,
                Width: 0,
                Length: 0,
                Weight: 0,
                PackageType: '',
                Description: '',
                TrackingReference: '',
                CustomReference: '',
            })
            this.watchItems()
        },

        async addDuplicateItem(item, packageGroup) {
            if (this.actor.ActorID && this.blcPackageId) {
                let duplicatedItem = { ...item, PackageItemID: '' }
                await this.updatePackage(packageGroup)
                const newPackageItemID = await this.createItem(duplicatedItem)
                duplicatedItem = {
                    ...duplicatedItem,
                    PackageItemID: newPackageItemID,
                }
                this.blcPackage.PackageItems.push(duplicatedItem)
                this.prevWatches.push(
                    this.$watch(
                        () => {
                            return duplicatedItem
                        },
                        _.debounce((newVal) => {
                            this.updateOrCreatePackageItem(newVal)
                        }, 300),
                        {
                            deep: true,
                        }
                    )
                )
            } else {
                let duplicatedItem = { ...item, PackageItemID: '' }
                this.blcPackage.PackageItems.push(duplicatedItem)
            }
        },

        async deleteItem(item) {
            try {
                await this.$confirm(
                    this.$i18n.i18next.t('message.warning.delete', {
                        section: 'item',
                    }),
                    'Warning',
                    {
                        confirmButtonText: this.$i18n.i18next.t(
                            'button.text.confirm'
                        ),
                        cancelButtonText: this.$i18n.i18next.t(
                            'button.text.cancel'
                        ),
                        type: 'warning',
                    }
                )

                if (item.PackageItemID) {
                    this.$http.delete(
                        `/Actor/${this.actor.ActorID}/PackageGroup/${this.blcPackageId}/PackageItem/${item.PackageItemID}`
                    )
                }

                let index = this.blcPackage.PackageItems.indexOf(item)

                this.blcPackage.PackageItems.splice(index, 1)
            } catch (e) {
                //
            }
        },

        selectSupplier(supplier) {
            this.blcPackage.SupplierID = supplier.SupplierID
            this.blcPackage.SupplierName = supplier.SupplierName
        },
    },
}
</script>
